// removed by extract-text-webpack-plugin
module.exports = {"description":"_34ydea4mzUoNU9W0bSs5QY"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/ShortDescFieldset.scss
// module id = 1451
// module chunks = 0